var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 32,
    viewBox: "0 0 49 32",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 32H12.5C6.24869 32.0037 1.04174 27.2077 0.53268 20.9772C0.0236195 14.7467 4.383 9.16907 10.552 8.158C13.3914 3.12377 18.7202 0.00702181 24.5 -0.000115684C28.104 -0.0137386 31.6048 1.2026 34.424 3.448C37.1921 5.64371 39.1602 8.68995 40.024 12.116C45.1918 12.9101 48.8756 17.551 48.476 22.7642C48.0764 27.9774 43.7284 32.0028 38.5 32ZM24.5 3.99998C20.1634 4.00511 16.1653 6.3442 14.036 10.122L13.1 11.8L11.202 12.11C7.10252 12.7968 4.21197 16.5086 4.55038 20.6514C4.88879 24.7941 8.3434 27.9876 12.5 28H38.5C41.6371 28.0032 44.2472 25.5892 44.4884 22.4613C44.7296 19.3335 42.5205 16.5478 39.42 16.07L36.788 15.67L36.144 13.086C34.8145 7.73962 30.0091 3.98991 24.5 3.99998ZM27.4 24H21.6V18H16.5L24.5 10L32.5 18H27.4V24Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/uploadFile.8a448010.svg";
export { ForwardRef as ReactComponent };